import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface Props {
  onConfirm(): void
}

export const DocumentConfirmationModal: BaseModalType<Props> = ({ onConfirm, close }) => {
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('Sign up.Skip document upload?')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t(
            'Sign up.You can skip document upload, but uploading documents is required step to become Tickmill customer.'
          )}
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>
          {t('Sign up.Back to Upload')}
        </Modal.Footer.Secondary>
        <Modal.Footer.Primary
          onClick={() => {
            onConfirm()
            close()
          }}
        >
          {t('Sign up.Skip upload')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
